import React, { Component } from "react";
import "../../styles/ErrorBoundary.css";

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Application render error:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  handleGoBack = () => {
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <main className="error-boundary" role="alert">
          <h1>Something went wrong</h1>
          <p>The page could not be displayed. Please try again.</p>
          <div className="error-buttons">
            <button
              type="button"
              className="go-back-button"
              onClick={this.handleRetry}
            >
              Go Back
            </button>
            <button
              type="button"
              className="try-again-button"
              onClick={this.handleRetry}
            >
              Try again
            </button>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
